export default Object.freeze({
  UNREAD_MESSAGES: 'unreadMessages',
  OFFLINE: 'offline'
})
